// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__32qtt","head":"Table_head__2KbAj","col":"Table_col__3xcVk"};